import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=0728f43a&"
import script from "./FAQ.vue?vue&type=script&lang=ts&"
export * from "./FAQ.vue?vue&type=script&lang=ts&"
import style0 from "./FAQ.vue?vue&type=style&index=0&id=0728f43a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports